"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeviewList = void 0;
var React = require("react");
var _1 = require(".");
var TreeviewList = function (props) {
    return (React.createElement(React.Fragment, null, props.Data &&
        props.Data.map(function (item, index) { return React.createElement(TreeRow, { OnExpandCollapse: props.OnExpandCollapse, FirstElement: props.FirstElement && index === 0, key: item.UniqueID, Item: item, Props: props }); })));
};
exports.TreeviewList = TreeviewList;
var TreeRow = function (_a) {
    var Item = _a.Item, Props = _a.Props, FirstElement = _a.FirstElement, OnExpandCollapse = _a.OnExpandCollapse;
    return (Item.Folder ?
        React.createElement(_1.TreeviewFolder, { Item: __assign({}, Item), FirstElement: FirstElement, RenderFolder: Props.RenderFolder, OnFocusEvent: Props.OnFocusEvent, OnKeyDownEvent: Props.OnKeyboardMovementEvent, OnDataRequest: Props.OnDataRequest, OnExpandCollapse: OnExpandCollapse, IndentAmount: Props.IndentAmount, SelectedItemID: Props.SelectedItemID, SpaceAfterGroup: Props.SpaceAfterGroup, FullWidthFocusStyling: Props.FullWidthFocusStyling },
            React.createElement(exports.TreeviewList, { Data: Item.Children, OnFocusEvent: Props.OnFocusEvent, OnDataRequest: Props.OnDataRequest, OnKeyboardMovementEvent: Props.OnKeyboardMovementEvent, RenderFolder: Props.RenderFolder, OnExpandCollapse: Props.OnExpandCollapse, RenderItem: Props.RenderItem, IndentAmount: Props.IndentAmount, SelectedItemID: Props.SelectedItemID, SpaceAfterGroup: Props.SpaceAfterGroup, FullWidthFocusStyling: Props.FullWidthFocusStyling }))
        :
            React.createElement(_1.TreeviewItem, { Item: Item, OnKeyDownEvent: Props.OnKeyboardMovementEvent, RenderItem: Props.RenderItem, FullWidthFocusStyling: Props.FullWidthFocusStyling, SelectedItemID: Props.SelectedItemID }));
};
